<script setup>
import { computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { useAccount } from 'dashboard/composables/useAccount';

const route = useRoute();
const router = useRouter();
const { t } = useI18n();
const { accountId } = useAccount();
const emit = defineEmits(['toggle-sidebar']);

const currentRouteName = computed(() =>
  route.name ? route.name.toString() : ''
);

const navItems = computed(() => [
  {
    key: 'mine',
    label: t('MOBILE_NAV.MINE'),
    icon: 'i-lucide-user-round',
    routeName: 'conversation_participating',
    isActive(name) {
      if (!name) return false;
      return name.includes('participating');
    },
  },
  {
    key: 'unassigned',
    label: t('MOBILE_NAV.UNATTENDED'),
    icon: 'i-lucide-inbox',
    routeName: 'conversation_unattended',
    isActive(name) {
      if (!name) return false;
      return name.includes('unattended');
    },
  },
  {
    key: 'menu',
    label: t('MOBILE_NAV.MENU'),
    icon: 'i-lucide-menu',
    action: 'menu',
    isActive() {
      return false;
    },
  },
]);

const handleNavigation = item => {
  if (item?.action === 'menu') {
    emit('toggle-sidebar');
    return;
  }
  if (!item?.routeName) {
    return;
  }

  router.push({
    name: item.routeName,
    params: {
      accountId: accountId.value,
    },
  });
};
</script>

<template>
  <nav
    class="flex items-center justify-between border-t border-n-weak bg-n-solid-1 px-2 py-2 shadow-[0_-2px_8px_rgba(15,23,42,0.08)]"
  >
    <button
      v-for="item in navItems"
      :key="item.key"
      type="button"
      class="flex flex-1 flex-col items-center gap-1 rounded-lg px-2 py-1 text-xs font-medium transition-colors"
      :class="
        item.isActive(currentRouteName)
          ? 'text-n-brand'
          : 'text-n-slate-11 dark:text-n-slate-12'
      "
      @click="handleNavigation(item)"
    >
      <Icon
        :icon="item.icon"
        class="text-base"
        :class="item.isActive(currentRouteName) ? 'text-n-brand' : ''"
      />
      <span class="truncate">{{ item.label }}</span>
    </button>
  </nav>
</template>
